<template>
  <v-app style="background-color: rgb(220,220,220);">
    <v-main>
      <NavBar />
      <router-view class="mt-5" />
    </v-main>
  </v-app>
  <NotificationsManager></NotificationsManager>
</template>

<script setup>
import NavBar from "./components/NavBar.vue";
import jwtDecode from "jwt-decode";
import { useAuthStore } from "./store/auth";
import { onMounted } from "vue";
import NotificationsManager from "./components/NotificationsManager.vue";

const authStore = useAuthStore();
async function mounted() {
  let refreshToken = localStorage.getItem("refreshToken");


  if (refreshToken != null) {
    let decodedToden = jwtDecode(refreshToken);

    let exp = new Date(decodedToden.exp * 1000);

    let scandeza = exp.valueOf() - Date.now().valueOf();

    console.log("Token scandeza: " + new Date(decodedToden.exp * 1000));

    if (scandeza > 0) {
      //Token valido
      authStore.refresh_token = refreshToken;

      await authStore.refresh_access_token();

      await authStore.setIntervalRefreshToken();
    } else {
      authStore.logout();
    }
  }
}

onMounted(mounted);
</script>


<style>

@font-face {
  font-family: 'Montserrat';
  src: url("@/assets/fonts/Montserrat-Light.ttf");
  font-weight: 300;
}

@font-face {
  font-family: 'Montserrat';
  src: url("@/assets/fonts/Montserrat-Regular.ttf") format("truetype");
  font-weight: 400;
}

@font-face {
  font-family: 'Montserrat';
  src: url("@/assets/fonts/Montserrat-Bold.ttf") format("truetype");
  font-weight: 700;
}

@font-face {
  font-family: 'Montserrat';
  src: url("@/assets/fonts/Montserrat-ExtraBold.ttf") format("truetype");
  font-weight: 800;
}

h1, h2, h3, h4, h5, h6 {
  font-family:'Montserrat';
}

.v-card-title {
  font-family: 'Montserrat';
}

.padding05 {
  padding: 5px;
}

</style>